export const UserPositionName = {
  OWNER: 'Owner',
  BUYER: 'Buyer',
  SALES_MANAGER: 'Sales Manager',
  OTHER: 'Other',
};
